import getAngularModule from 'App/babel/angularHelpers/getAngularModule';
import moment from 'moment';
import { openEditOrder } from 'App/components/EditOrder';

export const makeIterator = (startDate, endDate, unit = 'month', stepSize = 1) => {
	const currentPosition = moment(startDate);

	return {
		*[Symbol.iterator]() {
			do {
				yield moment(currentPosition);
				currentPosition.add(stepSize, unit);
			} while (currentPosition.isSameOrBefore(endDate));
		}
	};
};

export const editOpportunity = opportunity => {
	const AppService = getAngularModule('AppService');
	const customerId = AppService.getCustomerId();
	openEditOrder({ type: 'opportunity', customerId, id: opportunity.id, showPeriodizing: true });
};

export const SIDEBAR_WIDTH = 218;
